<template>
  <div class="flex justify-center relative mb-4">
    <el-button type="primary" @click="toggleExpand" class="w-1/2 mt-2">
      <Icon
        :icon="isExpanded ? 'fa-solid:chevron-up' : 'fa-solid:chevron-down'"
        class="mr-4"
      />
      Table Filter Options
    </el-button>
    <div
      ref="contentRef"
      :class="{
        'max-h-[200px]': isExpanded,
        'max-h-0': !isExpanded,
      }"
      class="absolute top-full left-1/4 right-1/4 overflow-hidden transition-all duration-300 ease-in-out bg-gray-900/90 rounded-br-lg rounded-bl-lg mt-1 z-50"
    >
      <div class="p-4">
        <el-tooltip
          disabled
          content="Show only reviewers who selected 'yes' for public review and navigated to the review page"
          placement="top"
        >
          <div class="flex items-center">
            <el-checkbox
              v-model="tableFilter.isFiltered"
              @change="handleFilter"
              class="text-white"
            >
              Filter Yes Reviews
            </el-checkbox>
            <Icon icon="material-symbols:filter-alt" class="ml-2" />
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from "vue";
import { Icon } from "@iconify/vue";
import { useReviewers } from "@/stores";
import { useTableFilter } from "@/stores/tableFilterStore";
import useExpandable from "@/composables/useExpandable";

const reviewersStore = useReviewers();
const tableFilter = useTableFilter();
const { isExpanded, contentRef, toggleExpand } = useExpandable();

const emit = defineEmits(["update:filtered"]);

const handleClickOutside = (event) => {
  const dropdownEl = contentRef.value;
  const buttonEl = event.target.closest("button");
  if (
    isExpanded.value &&
    dropdownEl &&
    !dropdownEl.contains(event.target) &&
    !buttonEl
  ) {
    toggleExpand();
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

const handleFilter = async () => {
  if (tableFilter.isFiltered) {
    await reviewersStore.fetchYesChoiceReviewers(0, 10);
  } else {
    await reviewersStore.fetchReviewers(1, 10, true);
  }
  emit("update:filtered", tableFilter.isFiltered);
};
</script>

<style scoped></style>
